/*
  Wishlist JS
  Failas: assets/wishlist.js
  Saugo prekes localStorage 7 dienoms. Accounto nereikia.
*/

(function () {
  var STORAGE_KEY = 'vr_wishlist_items_v1';
  var EXPIRY_KEY = 'vr_wishlist_expiry_v1';
  var DAYS_TO_KEEP = 7;
  var MS_PER_DAY = 24 * 60 * 60 * 1000;

  function now() {
    return Date.now();
  }

  function setExpiry() {
    try {
      localStorage.setItem(EXPIRY_KEY, String(now() + DAYS_TO_KEEP * MS_PER_DAY));
    } catch (e) {}
  }

  function isExpired() {
    try {
      var expiry = Number(localStorage.getItem(EXPIRY_KEY));
      return expiry && now() > expiry;
    } catch (e) {
      return false;
    }
  }

  function clearIfExpired() {
    if (isExpired()) {
      try {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(EXPIRY_KEY);
      } catch (e) {}
    }
  }

  function getItems() {
    clearIfExpired();

    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      setExpiry();
    } catch (e) {}
  }

  function itemExists(handle) {
    return getItems().some(function (item) {
      return item.handle === handle;
    });
  }

  function addItem(item) {
    var items = getItems();

    if (!items.some(function (existing) { return existing.handle === item.handle; })) {
      items.unshift(item);
      saveItems(items);
    }
  }

  function removeItem(handle) {
    var items = getItems().filter(function (item) {
      return item.handle !== handle;
    });

    saveItems(items);
  }

  function getItemFromButton(button) {
    return {
      handle: button.getAttribute('data-product-handle'),
      id: button.getAttribute('data-product-id'),
      title: button.getAttribute('data-product-title'),
      url: button.getAttribute('data-product-url'),
      image: button.getAttribute('data-product-image'),
      price: button.getAttribute('data-product-price')
    };
  }

  function updateButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-button]');

    buttons.forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var active = itemExists(handle);
      var icon = button.querySelector('[data-wishlist-icon]');
      var text = button.querySelector('[data-wishlist-text]');

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

     if (icon) {
  var emptyIcon = button.getAttribute('data-wishlist-icon-empty') || '♡';
  var activeIcon = button.getAttribute('data-wishlist-icon-active') || '♥';
  icon.textContent = active ? activeIcon : emptyIcon;
}
      if (text) text.textContent = active ? 'Pridėta į norų sąrašą' : 'Į norų sąrašą';
    });
  }

  function updateWishlistCount() {
    var wishlist = getItems();

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = wishlist.length;

      if (wishlist.length === 0) {
        el.style.display = 'none';
      } else {
        el.style.display = 'block';
      }
    });
  }

  function renderWishlistPage() {
    var grid = document.getElementById('vr-wishlist-grid');
    var empty = document.getElementById('vr-wishlist-empty');

    if (!grid) return;

    var items = getItems();
    grid.innerHTML = '';

    if (!items.length) {
      if (empty) empty.hidden = false;
      grid.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    grid.hidden = false;

    items.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'vr-wishlist-card';

      card.innerHTML =
        '<a class="vr-wishlist-card__image" href="' + item.url + '">' +
          (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="vr-wishlist-card__content">' +
          '<a class="vr-wishlist-card__title" href="' + item.url + '">' + escapeHtml(item.title) + '</a>' +
          '<div class="vr-wishlist-card__price">' + escapeHtml(item.price || '') + '</div>' +
          '<div class="vr-wishlist-card__actions">' +
            '<a class="button button--primary" href="' + item.url + '">Peržiūrėti prekę</a>' +
            '<button type="button" class="vr-wishlist-card__remove" data-wishlist-remove="' + item.handle + '">Pašalinti</button>' +
          '</div>' +
        '</div>';

      grid.appendChild(card);
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function refreshWishlist() {
    updateButtons();
    renderWishlistPage();
    updateWishlistCount();
  }

  document.addEventListener('click', function (event) {
    var wishlistButton = event.target.closest('[data-wishlist-button]');
    var removeButton = event.target.closest('[data-wishlist-remove]');

    if (wishlistButton) {
      event.preventDefault();

      var item = getItemFromButton(wishlistButton);
      if (!item.handle) return;

      if (itemExists(item.handle)) {
        removeItem(item.handle);
      } else {
        addItem(item);
      }

      refreshWishlist();
    }

    if (removeButton) {
      event.preventDefault();

      removeItem(removeButton.getAttribute('data-wishlist-remove'));
      refreshWishlist();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    refreshWishlist();
  });

  document.addEventListener('shopify:section:load', function () {
    refreshWishlist();
  });
})();